import MaterialTextField from '@material-ui/core/TextField';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useFormContext } from '../../contexts/formContext';
import Tooltip from '../Tooltip';
import useFieldStyles from './Field.styles';

const TextField = ({ className, name, label, placeholder, disabled, readOnly, maxLength, type, classes, suffix, inputClassName, onBlur }) => {
  const fieldClasses = useFieldStyles();

  const [field, meta] = useField({ name });

  const { disabled: formDisabled } = useFormContext();

  const errorMessage = useMemo(() => (meta.touched && meta.error ? meta.error : ''), [meta.touched, meta.error]);

  return (
    <div className={className}>
      <Tooltip title={errorMessage} placement="bottom" classes={{ tooltip: fieldClasses.tooltip }}>
        <MaterialTextField
          id={name}
          classes={classes || { root: fieldClasses.root }}
          fullWidth
          type={type}
          name={field.name}
          value={field.value}
          onChange={field.onChange}
          placeholder={placeholder}
          label={label}
          disabled={formDisabled || disabled}
          error={!!(meta.touched && meta.error)}
          InputProps={{
            readOnly,
            endAdornment: suffix && <span className={fieldClasses.suffix}>{suffix}</span>,
            inputProps: {
              onBlur,
              maxLength,
              className: inputClassName,
            },
          }}
        />
      </Tooltip>
    </div>
  );
};

TextField.propTypes = {
  classes: PropTypes.shape(),
  disabled: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  suffix: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  onBlur: PropTypes.func,
};

TextField.defaultProps = {
  classes: undefined,
  disabled: false,
  label: '',
  maxLength: undefined,
  placeholder: '',
  readOnly: false,
  suffix: undefined,
  type: 'text',
  className: undefined,
  inputClassName: undefined,
  onBlur: () => undefined,
};

export default React.memo(TextField);
